import * as React from 'react';

interface CarouselItemContextData {
    active: boolean;
    children?: React.ReactNode;
}

export const CarouselItemContextV2: React.Context<CarouselItemContextData> =
    React.createContext<CarouselItemContextData>({active: true});

export const CarouselItemContextProvider = ({
    active,
    children
}: CarouselItemContextData) => (
    <CarouselItemContextV2.Provider value={{active}}>
        {children}
    </CarouselItemContextV2.Provider>
);
